export default __webpack_public_path__ + "static/media/summary3.db78fd30.svg";